module.exports = __webpack_public_path__ + "static/img/icon_search.71b233e4.png";